import O from "./highrise1014.mjs";
import P from "./highrise987.mjs";
import { changeColor as n } from "./highrise993.mjs";
function B(p) {
  const {
    textColor2: o,
    textColor3: x,
    textColorDisabled: t,
    primaryColor: i,
    primaryColorHover: d,
    inputColor: r,
    inputColorDisabled: b,
    borderColor: a,
    warningColor: e,
    warningColorHover: s,
    errorColor: l,
    errorColorHover: c,
    borderRadius: g,
    lineHeight: C,
    fontSizeTiny: u,
    fontSizeSmall: h,
    fontSizeMedium: m,
    fontSizeLarge: $,
    heightTiny: f,
    heightSmall: H,
    heightMedium: S,
    heightLarge: v,
    actionColor: F,
    clearColor: D,
    clearColorHover: W,
    clearColorPressed: E,
    placeholderColor: T,
    placeholderColorDisabled: L,
    iconColor: w,
    iconColorDisabled: z,
    iconColorHover: y,
    iconColorPressed: j,
    fontWeight: M
  } = p;
  return Object.assign(Object.assign({}, O), {
    fontWeight: M,
    countTextColorDisabled: t,
    countTextColor: x,
    heightTiny: f,
    heightSmall: H,
    heightMedium: S,
    heightLarge: v,
    fontSizeTiny: u,
    fontSizeSmall: h,
    fontSizeMedium: m,
    fontSizeLarge: $,
    lineHeight: C,
    lineHeightTextarea: C,
    borderRadius: g,
    iconSize: "16px",
    groupLabelColor: F,
    groupLabelTextColor: o,
    textColor: o,
    textColorDisabled: t,
    textDecorationColor: o,
    caretColor: i,
    placeholderColor: T,
    placeholderColorDisabled: L,
    color: r,
    colorDisabled: b,
    colorFocus: r,
    groupLabelBorder: `1px solid ${a}`,
    border: `1px solid ${a}`,
    borderHover: `1px solid ${d}`,
    borderDisabled: `1px solid ${a}`,
    borderFocus: `1px solid ${d}`,
    boxShadowFocus: `0 0 0 2px ${n(i, {
      alpha: 0.2
    })}`,
    loadingColor: i,
    // warning
    loadingColorWarning: e,
    borderWarning: `1px solid ${e}`,
    borderHoverWarning: `1px solid ${s}`,
    colorFocusWarning: r,
    borderFocusWarning: `1px solid ${s}`,
    boxShadowFocusWarning: `0 0 0 2px ${n(e, {
      alpha: 0.2
    })}`,
    caretColorWarning: e,
    // error
    loadingColorError: l,
    borderError: `1px solid ${l}`,
    borderHoverError: `1px solid ${c}`,
    colorFocusError: r,
    borderFocusError: `1px solid ${c}`,
    boxShadowFocusError: `0 0 0 2px ${n(l, {
      alpha: 0.2
    })}`,
    caretColorError: l,
    clearColor: D,
    clearColorHover: W,
    clearColorPressed: E,
    iconColor: w,
    iconColorDisabled: z,
    iconColorHover: y,
    iconColorPressed: j,
    suffixTextColor: o
  });
}
const k = {
  name: "Input",
  common: P,
  self: B
};
export {
  k as default
};
